<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Fabricante</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-8">
                    <label for="Name">
                      <span class="required">*</span> Nome fantasia:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="Name"
                      class="form-control"
                      v-model="manufacturer.name"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Status">
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="manufacturer.status" class="form-control">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="CompanyName">Razão social:</label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="CompanyName"
                      class="form-control"
                      v-model="manufacturer.company_name"
                      placeholder=""
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-3">
                    <label for="Cnpj">CNPJ:</label>
                    <input
                      autocomplete="new-password"
                      class="form-control"
                      id="Cnpj"
                      placeholder=""
                      type="text"
                      v-model="manufacturer.cnpj"
                      v-mask="'99.999.999/9999-99'"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Cnes">CNES:</label>
                    <input
                      autocomplete="new-password"
                      class="form-control"
                      id="Cnes"
                      placeholder=""
                      type="text"
                      v-model="manufacturer.cnes"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Phone">Telefone/Celular:</label>
                    <input
                      autocomplete="new-password"
                      class="form-control"
                      id="Phone"
                      placeholder=""
                      type="text"
                      v-model="manufacturer.phone"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Email">Email:</label>
                    <input
                      autocomplete="new-password"
                      class="form-control"
                      id="Email"
                      placeholder=""
                      type="email"
                      v-model="manufacturer.email"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-2">
                    <label>CEP</label>
                    <input
                      v-model="manufacturer.cep"
                      type="tel"
                      class="form-control"
                      v-mask="'99999-999'"
                      v-on:keyup="buscar"
                    />
                  </div>
                  <div class="form-group col-md-5">
                    <label>Logradouro</label>
                    <input
                      v-model="manufacturer.street"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Número</label>
                    <input
                      v-model="manufacturer.number"
                      type="text"
                      class="form-control"
                      id="inputNumero"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Complemento</label>
                    <input
                      v-model="manufacturer.complement"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Bairro</label>
                    <input
                      v-model="manufacturer.neighborhood"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label>Cidade</label>
                    <input
                      v-model="manufacturer.city"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label>Estado</label>
                    <input
                      v-model="manufacturer.state"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/manufacturers" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "manufacturerAdd",
  data() {
    return {
      pageLoading: true,
      manufacturer: {
        name: "",
        company_name: "",
        cnpj: "",
        cnes: "",
        phone: "",
        email: "",
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
        status: "",
      },
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "manufacturers";

      if (self.manufacturer.id) {
        api += "/" + self.manufacturer.id;
        self.manufacturer._method = "PUT";
      }

      axios
        .post(api, self.manufacturer)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/manufacturers");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.manufacturer.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.manufacturer.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              $("#inputNumero").focus();
              return;
            }
            self.manufacturer.street = endereco.logradouro;
            self.manufacturer.neighborhood = endereco.bairro;
            self.manufacturer.state = endereco.uf;
            self.manufacturer.city = endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getManufacturer: function (id) {
      const self = this;
      const api = self.$store.state.api + "manufacturers/" + id;

      return axios
        .get(api)
        .then((response) => {
          self.manufacturer = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  async mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.pageLoading = true;

    try {
      if (id) {
        await self.getManufacturer(id);
      }
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>
